export const getRoleAppearance = (role, accountType = '') => {
  const sharedShell = {
    appBarBg: '#FFFFFF',
    accent: '#431FAD',
    shellBg: '#F9F9FB',
    shellGlow: 'none',
  };

  if (role === 'admin') {
    return {
      ...sharedShell,
      label: 'Super Admin',
      chipBg: 'rgba(179, 69, 44, 0.12)',
      chipColor: '#8E2F1B',
    };
  }

  if (role === 'data-provider') {
    return {
      ...sharedShell,
      label: accountType === 'individual_provider' ? 'Individual Provider' : 'Vendor Workspace',
      chipBg: 'rgba(16, 118, 112, 0.12)',
      chipColor: '#0E6E68',
    };
  }

  return {
    ...sharedShell,
    label: '',
    chipBg: '',
    chipColor: '',
  };
};
